import { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FiHome,
  FiCalendar,
  FiBarChart2,
  FiUser,
  FiLogOut,
  FiMoreHorizontal,
  FiBookOpen,
  FiUserX, // Ikon guru tidak hadir
} from "react-icons/fi";
import { AuthContext } from "../../context/AuthContext";

const sidebarItems = [
  { to: "/pimpinan", label: "Beranda", icon: FiHome },
  { to: "/pimpinan/jadwal", label: "Jadwal", icon: FiCalendar },
  { to: "/pimpinan/rekap", label: "Rekapitulasi", icon: FiBarChart2 },
  { to: "/pimpinan/profil", label: "Profil", icon: FiUser },
];

export default function PimpinanLayout({ children }) {
  const [open, setOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    setOpen(false);
    logout();
  };

  return (
    <div className="min-h-screen bg-slate-100">
      {/* ================= SIDEBAR ================= */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-40
          w-64 bg-white shadow-lg
          transform transition-transform duration-300
          ${open ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        {/* LOGO */}
        <div className="px-6 py-5 flex items-center gap-3">
          <img
            src="/logo.png"
            alt="Logo"
            className="w-9 h-9 object-contain"
          />
          <h1 className="font-bold text-xl text-blue-700">SIPENSA</h1>
        </div>

        {/* MENU */}
        <nav className="px-4 flex flex-col h-[calc(100vh-80px)]">
          <div className="space-y-1">
            {sidebarItems.map((item) => {
              const isDashboard = item.to === "/pimpinan";

              const active = isDashboard
                ? location.pathname === "/pimpinan"
                : location.pathname.startsWith(item.to);

              return (
                <SidebarItem
                  key={item.to}
                  to={item.to}
                  icon={item.icon}
                  label={item.label}
                  active={active}
                  onClick={() => setOpen(false)}
                />
              );
            })}
          </div>

          {/* LOGOUT */}
          <div className="mt-auto px-4 py-4 border-t border-slate-200">
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-2 rounded-lg
                         text-sm font-medium text-red-600
                         hover:bg-red-50 transition"
            >
              <FiLogOut className="text-lg" />
              Keluar
            </button>
          </div>
        </nav>
      </aside>

      {/* OVERLAY MOBILE */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* ================= CONTENT ================= */}
      <div className="flex flex-col min-h-screen md:ml-64">
        <header
          className="bg-white shadow-sm px-6 py-4
                     flex items-center justify-between
                     sticky top-0 z-40"
        >
          <div className="flex items-center gap-4">
            <button
              className="md:hidden text-xl"
              onClick={() => setOpen(!open)}
            >
              ☰
            </button>

            <p className="font-semibold text-lg">
              Selamat Datang,{" "}
              <span className="text-blue-600">Pimpinan</span> 👋
            </p>
          </div>

          {/* DROPDOWN */}
          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-slate-600 hover:text-slate-800 transition"
            >
              <FiMoreHorizontal className="text-xl" />
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border text-sm z-50">

                <Link
                  to="/pimpinan/petunjuk"
                  className="flex items-center gap-2 px-4 py-2 hover:bg-slate-100"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiBookOpen className="text-slate-500" />
                  Petunjuk
                </Link>

                {/* ✅ KOREKSI: WARNA IKON DIUBAH MENJADI SLATE-500 */}
                <Link
                  to="/pimpinan/guru-absen"
                  className="flex items-center gap-2 px-4 py-2 hover:bg-slate-100 text-slate-700"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiUserX className="text-slate-500" />
                  Guru Tidak Hadir
                </Link>

                <Link
                  to="/pimpinan/profil"
                  className="flex items-center gap-2 px-4 py-2 hover:bg-slate-100"
                  onClick={() => setMenuOpen(false)}
                >
                  <FiUser className="text-slate-500" />
                  Profil
                </Link>

                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 text-left"
                >
                  <FiLogOut />
                  Keluar
                </button>

              </div>
            )}
          </div>
        </header>

        <main className="p-4 md:p-6 bg-slate-100 flex-1">
          {children}
        </main>
      </div>
    </div>
  );
}

/* ================= SIDEBAR ITEM ================= */
function SidebarItem({ to, icon: Icon, label, active, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`flex items-center gap-3 px-4 py-2 rounded-lg
        text-sm font-medium transition-all duration-200
        ${
          active
            ? "bg-blue-100 text-blue-700"
            : "text-slate-600 hover:bg-blue-50 hover:text-blue-600"
        }
      `}
    >
      {Icon && <Icon className="text-lg" />}
      {label}
    </Link>
  );
}